module.exports = __webpack_public_path__ + "img/ringProfile@2x.d88f077.jpg";